import styled from "styled-components";
import { TitleMobile } from "../../../../../base/text/title/views/mobile/index.js";
import { ScrollHorizontalItem } from "../../../../../structures/others/scroll-horizontal/styled.js";
export const MobileBanners = styled.div.withConfig({
    displayName: "styled__MobileBanners",
    componentId: "sc-b9d0f44d-0"
})`
	${ScrollHorizontalItem} {
		min-width: calc(95% - 8px);

		img {
			width: 100%;
		}
	}
`;
export const MobileBannersTitle = styled(TitleMobile).withConfig({
    displayName: "styled__MobileBannersTitle",
    componentId: "sc-b9d0f44d-1"
})`
	padding: 0 16px;
`;

//# sourceMappingURL=styled.js.map